
import {Icon, IconNode} from "lucide-react";
import React from "react";


const ArrowUpRightFromSquareIconNode: IconNode = [
    [
        "path",
        {
            d: "M14.75 1C13.9895 1 13.375 1.61445 13.375 2.375C13.375 3.13555 13.9895 3.75 14.75 3.75H18.3035L9.65391 12.4039C9.1168 12.941 9.1168 13.8133 9.65391 14.3504C10.191 14.8875 11.0633 14.8875 11.6004 14.3504L20.25 5.69648V9.25C20.25 10.0105 20.8645 10.625 21.625 10.625C22.3855 10.625 23 10.0105 23 9.25V2.375C23 1.61445 22.3855 1 21.625 1H14.75ZM4.4375 2.375C2.53828 2.375 1 3.91328 1 5.8125V19.5625C1 21.4617 2.53828 23 4.4375 23H18.1875C20.0867 23 21.625 21.4617 21.625 19.5625V14.75C21.625 13.9895 21.0105 13.375 20.25 13.375C19.4895 13.375 18.875 13.9895 18.875 14.75V19.5625C18.875 19.9406 18.5656 20.25 18.1875 20.25H4.4375C4.05937 20.25 3.75 19.9406 3.75 19.5625V5.8125C3.75 5.43437 4.05937 5.125 4.4375 5.125H9.25C10.0105 5.125 10.625 4.51055 10.625 3.75C10.625 2.98945 10.0105 2.375 9.25 2.375H4.4375Z",
            key: "path0ArrowUpRightFromSquare",
        }
    ]
];

interface ArrowUpRightFromSquareProps {
    size?: string | number;
    className?: string;
}

export default function ArrowUpRightFromSquare({ size, className }: ArrowUpRightFromSquareProps) {
    return (
        <Icon iconNode={ArrowUpRightFromSquareIconNode} size={size} className={className} fill="#5C5C5C" color="transparent" />
    );
}
